import Text from '../../../components/ui/text.tsx';

type RichTextPlaceholderProps = {
    onClick?: () => void;
    placeholderText?: string;
};

export const RichTextPlaceholder = ({ onClick, placeholderText }: RichTextPlaceholderProps) => {
    return (
        <div onClick={onClick} className="border w-full p-2 px-3 h-20 rounded-lg cursor-text bg-white">
            <Text color="neutral-600" className=" pointer-events-none select-none">
                {placeholderText}
            </Text>
        </div>
    );
};
